import React from 'react';
export function VolumesDetail() {
  const fisicaVols = [{
    vol: '📘 Vol. 1',
    content: 'Core Systems Academy — Puck-moving patterns and offensive flow foundations.'
  }, {
    vol: '📗 Vol. 2',
    content: 'Technical Masterclass — Biomechanics encyclopedia. Fix any stride with 5-word cues.'
  }, {
    vol: '📕 Vol. 3',
    content: 'The Session Builder — Scaling logic to manage any team size with zero downtime.'
  }, {
    vol: '📙 Vol. 4',
    content: 'Professional Blueprints — 50 complete session structures ready to deliver.'
  }, {
    vol: '📘 Vol. 5',
    content: 'Strategy & Systems — High-performance tactical patterns and special teams.'
  }, {
    vol: '📙 Vol. 6',
    content: 'The Elite Coach — Team identity, recruitment, and avoiding coach burnout.'
  }];
  const bookEmojis = ['📘', '📗', '📕', '📙', '📘', '📙'];
  const formatVolText = (volText: string) => {
    return volText + ':';
  };
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border" data-id="element-258">
      <div className="max-w-5xl mx-auto" data-id="element-259">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-260">
          Inside the <span className="text-brand-accent" data-id="element-261">Vault</span>
        </h2>
        <div className="max-w-2xl mx-auto flex flex-col gap-8" data-id="element-262">
          <div className="bg-brand-card border border-brand-accent/40 rounded-2xl p-6 md:p-8" data-id="element-263">
            <div className="mb-6" data-id="element-264">
              <h3 className="text-xl md:text-2xl font-heading font-bold uppercase mb-1 text-brand-accent" data-id="element-265">
                ⚡ 6 High-Quality PDF Volumes
              </h3>
              <p className="text-white/70 text-sm" data-id="element-266">
                For professional hockey coaches and directors
              </p>
            </div>
            <div className="space-y-5" data-id="element-267">
              {fisicaVols.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-268">
                  <span className="text-xl leading-none mt-0.5" data-id="element-269">
                    {bookEmojis[i]}
                  </span>
                  <p className="text-white/90 text-base leading-relaxed" data-id="element-270">
                    <span className="font-bold text-white mr-1" data-id="element-271">
                      {formatVolText(item.vol)}
                    </span>
                    {item.content}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}